import React from 'react';
import {
  Box, Typography, Paper, Chip, Button,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Switch,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { TabIndices } from '../../common/i-doc/i-doc.registry.ts';

export const MailingsSettingsTab: React.FC = () => (
  <Paper sx={{ p: 3 }} data-i-doc={TabIndices.SETTINGS_MAILINGS}>
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      <Typography variant="h6">Налаштування розсилок</Typography>
      <Chip
        label="MOCK DATA"
        color="warning"
        size="small"
        icon={<WarningIcon />}
        sx={{ ml: 2, fontWeight: 'bold' }}
      />
    </Box>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
      Керуйте каналами отримання повідомлень та звітів. Дані на цій сторінці наразі є демонстраційними.
    </Typography>

    <TableContainer>
      <Table sx={{ minWidth: 500 }}>
        <TableHead>
          <TableRow>
            <TableCell>Вид розсилки</TableCell>
            <TableCell align="center">Email</TableCell>
            <TableCell align="center">Telegram</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[
            { id: 'news', label: 'Новини системи' },
            { id: 'client_reports', label: 'Звіти клієнтів' },
            { id: 'payments', label: 'Сповіщення про оплату' },
            { id: 'marketing', label: 'Маркетингові пропозиції' },
          ].map((row) => (
            <TableRow key={row.id}>
              <TableCell component="th" scope="row">{row.label}</TableCell>
              <TableCell align="center"><Switch defaultChecked color="primary" /></TableCell>
              <TableCell align="center"><Switch defaultChecked color="primary" /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
      <Button variant="contained">Зберегти зміни</Button>
    </Box>
  </Paper>
);
